import './quote_line_table.scss';

import classNames from 'classnames';
import { arrayOf, bool, number } from 'prop-types';
import React from 'react';
import DoubleScrollBar from 'react-double-scrollbar';

import { countries } from '../../constants';
import getInfoTooltip from '../../generic/Tooltip/get-info-tooltip';
import QuoteLineRow from '../QuoteLineRow.container';
import QuoteLineTableSum from '../QuoteLineTableSum.container';
import HELP_TEXTS from '../utils/help-texts';
import QuoteLineCountryTableHeaders from './QuoteLineCountryTableHeaders';
import QuoteLineDetailRow from './QuoteLineDetailRow';

// If you change the table head, please remember to also adjust the QuoteLineRow component.
function QuoteLineTable({
  quoteLines,
  showDetails,
  isEditing,
  isDraftCampaignEnabled,
}) {
  return (
    <div className="table-responsive font-size-small">
      <DoubleScrollBar>
        <table
          className={classNames(
            'table table-striped c-quote-line-table',
            showDetails && 'c-quote-line-table--double-rows',
          )}
        >
          <thead>
            <tr>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <th
                colSpan="2"
                rowSpan="2"
                className="c-quote-line-table__column--actions"
              />
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <th
                rowSpan="2"
                className="c-quote-line-table__column--product-name sticky-left sticky-left-header"
              />
              <th
                rowSpan="2"
                className="c-quote-line-table__column--price-model"
              >
                Price Model
                {getInfoTooltip(HELP_TEXTS, 'priceModel', 'productsTable')}
              </th>
              <th rowSpan="2" className="c-quote-line-table__column--currency">
                Net Client Budget External
                {getInfoTooltip(
                  HELP_TEXTS,
                  'netClientBudgetExternal',
                  'productsTable',
                )}
              </th>
              <th rowSpan="2" className="c-quote-line-table__column--currency">
                Net Client Budget WKZ
                {getInfoTooltip(HELP_TEXTS, 'wkzBudget', 'productsTable')}
              </th>
              <th rowSpan="2" className="c-quote-line-table__column--currency">
                Co-Invest
                {getInfoTooltip(HELP_TEXTS, 'coInvest', 'productsTable')}
              </th>
              <th rowSpan="2" className="c-quote-line-table__column--discount">
                Free Service
                {getInfoTooltip(HELP_TEXTS, 'freeService', 'productsTable')}
              </th>
              <th rowSpan="2" className="c-quote-line-table__column--discount">
                Gross Offer Value
                {getInfoTooltip(HELP_TEXTS, 'grossOfferValue', 'productsTable')}
              </th>
              <th rowSpan="2" className="c-quote-line-table__column--discount">
                Management Fee
                {getInfoTooltip(HELP_TEXTS, 'adjustedFee', 'productsTable')}
              </th>
              <th rowSpan="2" className="c-quote-line-table__column--currency">
                Spendable Budget
                {getInfoTooltip(HELP_TEXTS, 'spendableBudget', 'productsTable')}
              </th>
              {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
              <th rowSpan="2" colSpan="2" />
              <th colSpan={countries.length + 1} className="border-0">
                Country Split
                {getInfoTooltip(HELP_TEXTS, 'countrySplit', 'productsTable')}
              </th>
            </tr>
            <tr>
              <QuoteLineCountryTableHeaders countries={countries} />
            </tr>
          </thead>
          <tbody>
            {quoteLines.map((id, index) => (
              <React.Fragment key={id}>
                <QuoteLineRow
                  id={id}
                  index={index}
                  isEditing={isEditing}
                  isDraftCampaignEnabled={isDraftCampaignEnabled}
                />
                {showDetails && <QuoteLineDetailRow id={id} />}
              </React.Fragment>
            ))}
            <tr>
              {isDraftCampaignEnabled ? (
                <td className="spacer" />
              ) : (
                <div className="spacer" />
              )}
            </tr>
          </tbody>
          <tfoot>
            <QuoteLineTableSum countries={countries} />
          </tfoot>
        </table>
      </DoubleScrollBar>
    </div>
  );
}

QuoteLineTable.propTypes = {
  quoteLines: arrayOf(number).isRequired,
  showDetails: bool,
  isEditing: bool,
  isDraftCampaignEnabled: bool.isRequired,
};

QuoteLineTable.defaultProps = {
  showDetails: false,
  isEditing: true,
};

export default QuoteLineTable;
